import React from 'react';
import { FaArrowUpRightFromSquare, FaEnvelope, FaGithub, FaLinkedin, FaPhone } from 'react-icons/fa6';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { SiFiverr } from "react-icons/si";

const contactLinks = [
  {
    label: 'Email',
    description: 'hassandevops786@gmail.com',
    href: 'mailto:hassandevops786@gmail.com',
    icon: FaEnvelope,
  },
  {
    label: 'Phone',
    description: '03347292454',
    href: 'tel:03347292454',
    icon: FaPhone,
  },
  {
    label: 'GitHub',
    description: 'Explore code and project work.',
    href: 'https://www.github.com/hassan-yousuf',
    icon: FaGithub,
  },
  {
    label: 'LinkedIn',
    description: 'Connect around opportunities and collaboration.',
    href: 'https://www.linkedin.com/in/hassan-sakaria',
    icon: FaLinkedin,
  },
  {
    label: 'Fiverr',
    description: 'View the existing freelance profile.',
    href: 'https://www.fiverr.com/hassanyousuf786',
    icon: SiFiverr,
  },
];

export default function Contact() {
  return (
    <section className="border-t border-slate-800/70 px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="contact">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">Get in touch</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Let&apos;s build something useful.</h2>
          <p className="mt-5 text-base leading-7 text-slate-400">For opportunities, projects, or collaboration, connect through one of the verified profiles below.</p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="space-y-4">
            {contactLinks.map(({ label, description, href, icon: Icon }) => (
              <a key={label} href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} className="focus-ring surface-card group flex items-center gap-3 p-4 transition hover:-translate-y-0.5 hover:border-slate-500 sm:gap-4 sm:p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-700 bg-slate-900 text-lg text-cyan-300 transition group-hover:border-cyan-300/50 group-hover:text-white">
                  <Icon aria-hidden="true" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-bold text-white">{label}</span>
                  <span className="mt-1 block text-sm leading-6 text-slate-500">{description}</span>
                </span>
                <FaArrowUpRightFromSquare className="shrink-0 text-slate-600 transition group-hover:text-cyan-300" aria-hidden="true" />
              </a>
            ))}
          </div>

          <div className="surface-card relative overflow-hidden p-6 sm:p-8">
            <div className="absolute right-0 top-0 h-40 w-40 rounded-full bg-indigo-400/10 blur-3xl" aria-hidden="true" />
            <div className="relative">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan-300">Choose a direct path</p>
              <h3 className="mt-5 max-w-md text-2xl font-extrabold tracking-tight text-white sm:text-3xl">Start with the place that fits the conversation.</h3>
              <p className="mt-4 max-w-lg text-sm leading-7 text-slate-400">Use LinkedIn for professional opportunities and collaboration, GitHub to review project work, or Fiverr for the existing freelance profile.</p>
              <div className="mt-8 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
                <p className="inline-flex items-center gap-2 text-sm text-slate-500"><FaMapMarkerAlt className="text-cyan-300" aria-hidden="true" />Karachi Central District, Sindh, Pakistan</p>
                <a href="https://www.linkedin.com/in/hassan-sakaria" target="_blank" rel="noopener noreferrer" className="focus-ring inline-flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-400 via-violet-400 to-cyan-300 px-6 py-3.5 text-sm font-extrabold text-slate-950 transition hover:-translate-y-0.5 hover:shadow-lg hover:shadow-indigo-500/20">Connect on LinkedIn <FaArrowUpRightFromSquare className="ml-2" aria-hidden="true" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
